let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6ff4v")).then(() => parcelRequire('hTI3Y'));